module.exports = __webpack_public_path__ + "img/ancient_of_hibernation_small.0d3287d4.png";